<div class="row">
  <div class="col-12 text-center">
    <img
      src="assets/images/full_foodxain_logo.png"
      class="img-fluid"
      alt="FoodXain"
    />
  </div>
</div>
